/**
 * Safely formats a date into Finnish locale yyyy-mm-dd (dots replaced with hyphens).
 * Returns the provided fallback (default empty string) when date is missing or invalid.
 */
export function formatFiDate(dateInput?: string | number | Date | null, fallback: string = ""): string {
    if (!dateInput) return fallback;
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) return fallback;

    // Example: 13.08.2025 -> 13-08-2025
    return d
        .toLocaleDateString("fi-FI", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
        .replace(/\./g, "-");
}
